import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getStudents = (groupId) => async (dispatch) => {
    dispatch({ type: 'STUDENTS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/students', {
            params: groupId ? { groupId } : {},
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'STUDENTS_SUCCESS', payload: data.students })
        }
    } catch (error) {
        dispatch({ type: 'STUDENT_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const getStudent = (studentId) => async (dispatch) => {
    dispatch({ type: 'STUDENTS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/teacher/students/' + studentId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({ type: 'STUDENT_SUCCESS', payload: data })
        }
    } catch (error) {
        dispatch({ type: 'STUDENT_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const addObservation = (studentId, observation) => async (dispatch) => {
    try {
        await Axios.post('/api/teacher/students/' + studentId + '/observation', { observation }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
    } catch (error) {
        dispatch({ type: 'STUDENT_ERROR', payload: error.response?.data?.message || error.message })
    }
}

export const addIncident = (studentId, type, description) => async (dispatch) => {
    try {
        await Axios.post('/api/teacher/students/' + studentId + '/incident', { type, description }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
    } catch (error) {
        dispatch({ type: 'STUDENT_ERROR', payload: error.response?.data?.message || error.message })
    }
}
